gsap.to("#title-image", {
  scale: 1,
  ease: "power2.out",
  scrollTrigger: {
    trigger: "#hero",
    start: "top bottom",
    end: "bottom top",
    scrub: true,
  },
});

gsap.to("#eye1-open", {
  duration: 0.5,
  morphSVG: {
    shape: "#eye1-close",
    // type: "rotational",
    // origin: "20% 60%", //or "20% 60%,35% 90%" if there are different values for the start and end shapes.
  },
  repeatDelay: 5,
  repeat: -1, // infinite loop
  yoyo: true,
});

gsap.to("#eye2-open", {
  duration: 0.5,
  morphSVG: {
    shape: "#eye2-close",
    // type: "rotational",
    // origin: "20% 60%", //or "20% 60%,35% 90%" if there are different values for the start and end shapes.
  },
  repeatDelay: 5,
  repeat: -1, // infinite loop
  yoyo: true,
});

gsap.to("#mouth-red", {
  duration: 0.5,
  morphSVG: {
    shape: "#mouth-big",
  },
  repeatDelay: 5,
  repeat: -1, // infinite loop
  yoyo: true,
});

// Hide #ear and show #ear-rotate, alternating every 3 seconds
 

gsap.to("#ear", {
  duration: 0.5,
  opacity: 0,
  repeatDelay: 5,
  repeat: -1, // infinite loop
  yoyo: true,
});

gsap.to("#ear-rotate", {
  duration: 0.5,
  opacity: 1,
  repeatDelay: 5,
  repeat: -1, // infinite loop
  yoyo: true,
});


gsap.to("#dog-left-ear", {
  duration: 1,
    rotate: 3,
  repeatDelay: 1,
  transformOrigin: "bottom",
  repeat: -1, // infinite loop
  yoyo: true,
});


// Main mouth + eyes timeline
const tl = gsap.timeline({ repeat: -1 });

// Reset initial states at the beginning of each cycle
tl.set("#dog-smile", { opacity: 0 })
  .set("#dog-mouth", { opacity: 1 })
  .set("#dog-right-eye, #dog-left-eye", { clearProps: "all" })
  .to({}, { duration: 4 }) // idle wait before smile

  // Step 2: mouth disappears, smile shows
  .to("#dog-mouth", { duration: 0.3, opacity: 0 })
  .to("#dog-smile", { duration: 0.3, opacity: 1 }, "<")

  // 👉 Eyes blink during smile (loop a couple of times)
  .to("#dog-right-eye", {
    duration: 0.3,
    morphSVG: { shape: "#dog-right-eye-close" },
    repeatDelay: 4,
    repeat: 1, // blink twice in this smile phase
    yoyo: true
  }, "<") // sync with smile
  .to("#dog-left-eye", {
    duration: 0.3,
    morphSVG: { shape: "#dog-left-eye-close" },
    repeatDelay: 4,
    repeat: 1,
    yoyo: true
  }, "<") // sync with right eye
    // Step 5: smile disappears
    .to("#dog-smile", { duration: 0.3, opacity: 0 })
  // Step 7: big mouth
  .to("#dog-mouth", {
    duration: 0.2,
    opacity: 1,
    morphSVG: { shape: "#dog-mouth-big" },
    repeatDelay: 2,
    repeat: 1,
    yoyo: true
  }, "<")
  .to("#dog-ear-inner", {
    duration: 0.2,
    opacity: 1,
    morphSVG: { shape: "#dog-ear-inner-rotate" },
    repeatDelay: 2,
    repeat: 1,
    yoyo: true
  }, "<")
  .to("#dog-ear", {
    duration: 0.2,
    opacity: 1,
    morphSVG: { shape: "#dog-ear-rotate" },
    repeatDelay: 2,
    repeat: 1,
    yoyo: true
  }, "<")
 